import { Component, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { DashboardService } from '../dashboard/dashboard.service';
import { ProfileService } from '../profile/profile.service';
import { Constants } from '../Constants';

@Component({
  selector: 'app-theme',
  templateUrl: './theme.component.html',
  styleUrls: ['./theme.component.scss']
})
export class ThemeComponent implements OnInit {

  themes = Constants.themes;

  selectedTheme;
  applyTheme;
	bgTextColor = "#2f3359";
  bgColor: string = '#E9F1F7';

  constructor(
    private _snackBar: MatSnackBar,
    private _profileService: ProfileService,
    private _dataSerivce: DashboardService,
  ) { }

  ngOnInit() {
    this.onInit();
  }

  onInit(): void {
    if (localStorage.getItem('bgTextColor')) this.bgTextColor = localStorage.getItem("bgTextColor");
    if (localStorage.getItem('bgColor')) this.bgColor = localStorage.getItem("bgColor");
  }

  selectTheme(theme) {
    this.selectedTheme = theme;
    this.applyTheme = theme;
    this.bgColor = this.applyTheme.background;
  }

  applyColor() {
    if (!this.applyTheme) return;
    const formData: FormData = new FormData();
    var data = {
      theme: {
        bg_color: this.applyTheme.background,
        bg_text_color: this.applyTheme.text
      },
      email: localStorage.getItem('email'),
      organization: localStorage.getItem('organization'),
    };
    
    this.bgColor = this.applyTheme.background;
    this.bgTextColor = this.applyTheme.text;
    this._profileService.updateTheme(data).subscribe((response) => {
      if (response['success']) {
        localStorage.setItem('bgColor', this.applyTheme.background);
        localStorage.setItem('bgTextColor', this.applyTheme.text);
      
        this._dataSerivce.setBgColor(this.applyTheme);
        this.applyTheme = null;
        this.openSnackBar("Theme applied successfully");
      }
    }, err => {
        console.log(err);
    });
  }

  openSnackBar(message) {
    this._snackBar.open(message, "Ok", {
      duration: 2000
    });
  }

}
